<template lang="pug">
  .base
    .row
      h2(:class="{blue: blue_base}") {{title}}
    .row
      h3 {{subTitle}}
    .row
      .message {{message}}
    .row(v-if="url != ''")
      a(:href="url" target="_blank")
        .logo
          img(:src="imagePath + image")
    .row(v-if="comment != ''")
      .comment {{comment}}
    .row
      .button_area(v-if="!blue_base")
        a(:href="url" target="_blank")
          button.red_button(v-html="button_label")
      .button_area(v-if="blue_base")
        button.blue_button(v-html="button_label" @click="go_mail")
</template>

<script lang="js">
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    comment: {
      type: String,
      default: '',
    },
    button_label: {
      type: String,
      default: '',
    },
    blue_base: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imagePath() {
      return process.env.BASE_URL;
    },
  },
  methods: {
    go_mail(e) {
      this.$emit('go_mail');
    },
  },
};
</script>

<style lang="sass" scoped>
.base
  margin-bottom: 80px
  .row
    h2
      color: $color-orange
    .blue
      color: $color-orange
    h3
      margin-top: 10px
    .message
      margin-top: 10px
    a
      width: 100%
      .logo
        display: flex
        align-items: center
        justify-content: center
        margin: 40px 20px
        img
          width: 100%
          max-width: 300px
    .comment
      background-color: $light-gray
      padding: 20px 40px
      width: 100%
      max-width: 760px
      margin: 20px auto
    .button_area
      margin-top: 40px
      a
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        text-decoration: none
      button
        width: 100%
        max-width: 360px
</style>